export default __webpack_public_path__ + "static/media/icon-login-password.2be05097.svg";